import React from "react";
import LayoutFull from '../layouts/layoutFull/LayoutFull';
import getPages from "../helpers/data/get/pages";
import SeoApiHandler from "../helpers/seo/SeoApiHandler";
import PageArticle, { preparePageArticle } from "../layouts/pages/article/PageArticle";
import { NAV_RETURN_POLICY } from "../settings/navigation";

export async function getStaticProps() {
    const seo = await getPages(NAV_RETURN_POLICY);
    return {
        props: {
            seo,
            article : preparePageArticle({page: seo})
        },
    }
}

function Terms({seo, article}) {
    return (
        <LayoutFull>
            <SeoApiHandler data={seo}/>
            <PageArticle page={article}/>
        </LayoutFull>
    );
}

export default Terms